import * as React from "react";
import { DiaryCompliance, Subject } from "webportalclient";
import { groupBy, maxBy } from "lodash";
import Modal from "../../misc/components/modal";
import { DateTimeAccuracy, LocalizedDateTime } from "../../misc/components/LocalizedDateTime";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";

interface DiaryBaselinesModalProps {
    subjectId: string;
    onClose: () => void;
}

export const DiaryBaselinesModal = ({ subjectId, onClose }: DiaryBaselinesModalProps) => {
    const client = useWebPortalApiClient();
    const [subject, setSubject] = React.useState<Subject | undefined>();

    React.useEffect(() => {
        const getSubjectBaselines = async () => {
            const subjectResult = await client.client.getSubject(subjectId, "baselinePEF,baseline1,baseline2,baseline3");
            setSubject(subjectResult);
        }

        getSubjectBaselines();
    }, [subjectId]);

    return (
        <Modal show={true} closeModalHandler={onClose} header="Subject Baselines">
            <div className="modal-body">
                {subject ?
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Baseline</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subject.baselinePef !== undefined && subject.baselinePef !== null ? <tr>
                                <td>
                                    Baseline PEF
                                </td>
                                <td>{subject.baselinePef} L/min</td>
                            </tr> : null}
                            {subject.baseline1 !== undefined && subject.baseline1 !== null ? <tr>
                                <td>
                                    Baseline PEF (Morning)
                                </td>
                                <td>{subject.baseline1} L/min</td>
                            </tr> : null}
                            {subject.baseline2 !== undefined && subject.baseline2 !== null ? <tr>
                                <td>
                                    Baseline PEF (Evening)
                                </td>
                                <td>{subject.baseline2} L/min</td>
                            </tr> : null}
                            {subject.baseline3 !== undefined && subject.baseline3 !== null ? <tr>
                                <td>
                                    Daily Rescue Medication Use Baseline
                                </td>
                                <td>{subject.baseline3}</td>
                            </tr> : null}
                        </tbody>
                    </table> : <LoadingWithMessage message="Loading Subject Baselines" />}
            </div>
        </Modal>
    );
}
